const getAssetUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (process.env.DEPLOY_ENV === 'local') {
    return normalizedPath;
  }

  const appUrl = process.env.CARVANA_APP_PUBLIC_URL;
  const prefix = `${appUrl}/next`;

  return `${prefix}${normalizedPath}`;
};

export default getAssetUrl;
